const twareasData = []
const countryData = [{ ID: 4, Name: '中國(台灣)' }]
const provinceData = [{ Country: 4, ID: 27, Name: '台灣省' }]
const cityData = [
  { Province: 27, ID: 316, Name: '台北市' },
  { Province: 27, ID: 317, Name: '高雄市' },
  { Province: 27, ID: 318, Name: '台南市' },
  { Province: 27, ID: 319, Name: '台中市' },
  { Province: 27, ID: 320, Name: '金門縣' },
  { Province: 27, ID: 321, Name: '南投縣' },
  { Province: 27, ID: 322, Name: '基隆市' },
  { Province: 27, ID: 323, Name: '新竹市' },
  { Province: 27, ID: 324, Name: '嘉義市' },
  { Province: 27, ID: 325, Name: '新北市' },
  { Province: 27, ID: 326, Name: '宜蘭縣' },
  { Province: 27, ID: 327, Name: '新竹縣' },
  { Province: 27, ID: 328, Name: '桃園縣' },
  { Province: 27, ID: 329, Name: '苗栗縣' },
  { Province: 27, ID: 330, Name: '彰化縣' },
  { Province: 27, ID: 331, Name: '嘉義縣' },
  { Province: 27, ID: 332, Name: '雲林縣' },
  { Province: 27, ID: 333, Name: '屏東縣' },
  { Province: 27, ID: 334, Name: '台東縣' },
  { Province: 27, ID: 335, Name: '花蓮縣' },
  { Province: 27, ID: 336, Name: '澎湖縣' },
]
//仅省市选择
for (const provinceItem of provinceData) {
  twareasData.push({
    value: provinceItem.ID, // 省份code值
    label: provinceItem.Name, // 省份汉字
    children: [],
  })
}

for (const provinceItem of twareasData) {
  for (const cityItem of cityData) {
    if (cityItem.Province === provinceItem.value) {
      provinceItem.children.push({
        value: cityItem.ID,
        label: cityItem.Name,
      })
    }
  }
}
export default twareasData



// WEBPACK FOOTER //
// ./src/utils/twareas.js